import { useState, useEffect } from 'react';

// Reusable hook: returns true while the given CSS media query matches, and
// re-renders whenever that changes (e.g. the user resizes or rotates).
export default function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const mql = window.matchMedia(query);
    const handler = (e) => setMatches(e.matches);
    setMatches(mql.matches);           // sync in case it changed before this ran
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, [query]);

  return matches;
}
